import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { ConstantService } from '../../components/common/utils/constant.service';
import { ClienteXCiudad } from '../login/cliente_login';
import { ConsultaCarpeta, Carpeta, Archivo, CarpetasArchivo, BuscaArchivos, Preguntas, Contacto } from '../../components/common/utils/entities/util_entity';
import { Header } from 'primeng/primeng';
import { ClientePersonaEmpresa } from '../register/entities/usuario_registro_entity';

declare var jQuery: any;

@Injectable()
export class MasivosVHComponentService {
    private userEmpresa: ClienteXCiudad;
    private url = "infoClienteIndividual";

    constructor(private authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }
    
    CosultaInformacion(vehcod: number,ciudad: number,unidad: number): Observable<ClientePersonaEmpresa>{
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/consultarInformacion/"+ vehcod+"/"+ciudad+"/"+unidad, options).map(this.extractData)
            .catch(this.handleError);
      }
      ConsultarPreguntas(conclicod: number): Observable<Preguntas>{
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/ConsultarPreguntas/"+ conclicod, options).map(this.extractData)
            .catch(this.handleError);
      }
      GenerarToken(datos: ClientePersonaEmpresa): Observable<ClientePersonaEmpresa> {
        let body = JSON.stringify(datos);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/GenerarToken", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    generarCartaAutorizacion(parametros: ClientePersonaEmpresa): Observable<any> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/pdf',
            'Authorization' : "Token " + sessionStorage.getItem("Token")
        });
        let options = new RequestOptions({ headers: headers });
        options.responseType = ResponseContentType.Blob;
        return this.authHttp.post(this.url + "/generarCartaAutorizacion/", body, options)
            .map(response => response).catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/MasivoContratacion/MasivosVH.service.ts